<template>
  <div class="preview">
    <div class="preview-screen" :class="[ orientation, layout ]">
      <div
        v-for="m in markets"
        :key="m"
        class="market"
        :class="layout"
      >
        <span class="title">Market {{ m }}</span>
        <div class="market-content">
          <div
            v-for="n in broadcasts"
            :key="n"
            class="broadcast"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutPreview',
  props: {
    layout: {
      type: String,
      default: '',
    },
    orientation: {
      type: String,
      default: '',
    },
    markets: {
      type: Number,
      default: 0,
    },
    broadcasts: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";
@import "~@/assets/scss/layout";

.preview {
  width: 480px;
  height: 400px;
  margin-top: 10px;
  box-sizing: border-box;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.05);
  border: solid 1px $charcoal-dark;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
}

.preview-screen {
  @extend %layout;
  width: 400px;
  height: 225px;
  padding: 2vh 3vh;
  grid-gap: 2.5vh;
  background-color: $charcoal-dim;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.24);
  box-sizing: border-box;
  transition: all 0.2s;

  &.portrait {
    height: 320px;
    width: 188px;
    padding: 3vh 2vh;
  }

  &.landscape-4k-4m {
    padding: 8px 25px 12px;
    grid-gap: 5px 30px;
  }

  &.landscape-4k {
    padding: 8px 25px 12px;
    grid-gap: 5px 10px;
  }

  .market {
    .market-content {
      grid-gap: 0;
    }
  }
}

.market {
  @extend %market;
}

.title {
  height: 20px;
  font-size: $size-8;
  font-weight: $weight-black;
  display: inline-block;
  text-transform: uppercase;
}

.broadcast {
  height: 100%;
  width: 100%;
  background-color: $charcoal;
  border: solid 2px $charcoal-dim;
  box-sizing: border-box;
}

@media screen and (max-width: 520px) {
  .preview {
    width: 100%;
    height: 250px;
    box-sizing: border-box;
  }

  .preview-screen {
    width: 220px;
    height: 134px;
    padding: 1.8vh 2vh;
    grid-gap: 1vh;

    &.portrait {
      height: 200px;
      width: 118px;
      padding: 2vh 1.8vh;
    }

    &.landscape-4k-4m {
      padding: 4px 20px 8px;
      grid-gap: 2px 20px;
    }

    &.landscape-4k {
      padding: 4px 8px 8px;
      grid-gap: 2px 8px;
    }
  }

  .title {
    font-size: $size-9;
  }
}
</style>
